export default __webpack_public_path__ + "static/media/pukinnlogo_porter.81073e03.png";